export const getFormations = () => {
  const formations = [
    {
      diplome: "Licence Professionnelle",
      ecole: "ÈCOLE SUPÈRIUERE DE TECHNOLOGIE  MEKNES",
      annee: "2021/2020",
      filiere: "Développement des Systèmes d’Information et de Communication",
    },
    {
      diplome: "DUT   ",
      ecole: "ÈCOLE SUPÈRIUERE DE TECHNOLOGIE MEKNES",
      annee: "2020/2018",
      filiere: "Génie informatique option génie Logiciel ",
    },
    {
      diplome: "BACCALAURÈAT",
      ecole: "LYCÈE MOHAMED V CASABLANCA",
      annee: "2021/2020",
      filiere: "Baccalauréat en sciences physiques",
    },
  ];
  return formations;
};
